import { Skeleton } from '@repo/ui/components/ui/skeleton';

const CommentsLoading = ({ count = 5 }: { count?: number }) => {
  return (
    <div className="flex flex-col gap-3">
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton key={index} className="w-full h-44" />
      ))}
    </div>
  );
};

export default CommentsLoading;
